const SIZE_STYLES: Record<
  NonNullable<CountLabelProps["size"]>,
  React.CSSProperties
> = {
  xs: {
    top: "-1px",
    right: "-1px",
    width: "19px",
    height: "19px",
    fontSize: "10px",
  },
  sm: {
    top: "-1px",
    right: "0px",
    width: "20px",
    height: "20px",
    fontSize: "10px",
  },
  lg: {
    top: "8px",
    right: "8px",
    width: "32px",
    height: "32px",
    fontSize: "14px",
  },
};

const VARIANT_STYLES: Record<
  NonNullable<CountLabelProps["variant"]>,
  React.CSSProperties
> = {
  primary: {
    color: "#1E1E1E",
    background: "radial-gradient(circle at 30% 30%, #FFEA70, #FFD700, #B8860B)",
    boxShadow: "0 0 2px 1px rgba(0, 0, 0, 0.5)",
  },
  secondary: {
    background: "#F1594E",
    color: "#fff",
    boxShadow: "0 0 2px 1px rgba(0, 0, 0, 0.5)",
  },
};

interface CountLabelProps {
  count?: number;
  size?: "xs" | "sm" | "lg";
  variant?: "primary" | "secondary";
  style?: React.CSSProperties;
}

const CountLabel = ({
  count,
  variant = "primary",
  size = "sm",
  style = {},
}: CountLabelProps) => {
  if (!count) return null;

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 2,

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        borderRadius: "50%",
        pointerEvents: "none",

        ...VARIANT_STYLES[variant],
        ...SIZE_STYLES[size],
        ...style,
      }}
    >
      <div
        style={{
          fontWeight: 600,
          letterSpacing: "0.05em",
          lineHeight: 1,
        }}
      >
        {count}
      </div>
    </div>
  );
};

export default CountLabel;
